import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { BASE_URL } from '@/constants/constant';

const baseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	prepareHeaders: (headers) => {
		const token = localStorage.getItem('token');
		if (token) {
			headers.set('Authorization', token);
		}

		return headers;
	}
});

export const baseApi = createApi({
	reducerPath: 'api',
	baseQuery,
	tagTypes: [
		'MoodBoards',
		'FactoryPOInfo',
		'Target',
		'Breakdowns',
		'MATERIAL_REQUISITIONS',
		'MATERIAL_REQUISITION_PRELIMINARY_ITEMS',
		'MATERIAL_REQUISITION_SUMMARY'
	],
	endpoints: () => ({})
});

export default baseApi;
